__turbopack_context__.v({
  "launcher": "GailGptLauncher-module__DkMUJW__launcher",
});
